import { CallerDTO, FormfieldValuesDTO, TranslationDTO } from './callback-on-callnote.model';
import { IconEnum } from './assets.model';
import { I18nFeedbackEnum } from './i18n.model';

export type FeedbackValidity = 'NOT_RATED' | 'VALID' | 'INVALID';

export interface IFeedbackElement {
	id: number;
	rating: number;
	created: string;
	callbackPhoneNumber: string;
	contactWish: boolean;
	customerAnnotation: string;
	detailedRating: ICheckboxes;
	praise: boolean;
	createdByService: boolean;
	validity: FeedbackValidity;
}

export interface ICheckboxes {
	ordersIgnored: boolean;
	unfriendlyCall: boolean;
	wrongNameOrCompany: boolean;
	wrongNotice: boolean;
	wrongTelephoneNumber: boolean;
}

export interface FeedbackCallnoteDTO {
	languageId: number;
	timeZone: string;
	callNote: {
		processingStart: string;
		subject: string;
		message: string | null;
		callReason: string | null;
		formfieldValues: FormfieldValuesDTO[];
		caller: CallerDTO;
		syncedWithAddressBook?: boolean;
	};
	feedback: IFeedbackElement | Record<string, never>;
	translations: TranslationDTO;
}

export interface DetailedFeedbackRequestDTO {
	rating: number;
	customerAnnotation: string;
	contactWish: boolean;
	callbackPhoneNumber: string;
	praise: boolean;
	detailedRating: ICheckboxes;
}

export interface FeedbackWorkflow {
	uid: string;
	rating: number;
}

export const POSITIVE_RATING_THRESHOLD = 4;
export const CALLBACK_PHONE_MAX_LENGTH = 30;
export const CALLBACK_PHONE_PATTERN = /^[a-zA-Z0-9+\s\-]*$/;

export const DEFAULT_CHECKBOXES: ICheckboxes = {
	ordersIgnored: false,
	unfriendlyCall: false,
	wrongNameOrCompany: false,
	wrongNotice: false,
	wrongTelephoneNumber: false,
};

export enum RateTypeEnum {
	DISAPPOINTING = 1,
	NOT_GOOD = 2,
	OK = 3,
	GOOD = 4,
	EXTRAORDINARY = 5,
}

export interface RatingConfig {
	value: number;
	icon: string;
	iconSelected: string;
	i18nKey: string;
}

export const RATINGS: RatingConfig[] = [
	{
		value: RateTypeEnum.DISAPPOINTING,
		icon: IconEnum.RATE_DISAPPOINTING,
		iconSelected: IconEnum.RATE_DISAPPOINTING_C,
		i18nKey: I18nFeedbackEnum.FEEDBACK_RATE_DISAPPOINTING,
	},
	{
		value: RateTypeEnum.NOT_GOOD,
		icon: IconEnum.RATE_NOT_GOOD,
		iconSelected: IconEnum.RATE_NOT_GOOD_C,
		i18nKey: I18nFeedbackEnum.FEEDBACK_RATE_NOT_GOOD,
	},
	{
		value: RateTypeEnum.OK,
		icon: IconEnum.RATE_OK,
		iconSelected: IconEnum.RATE_OK_C,
		i18nKey: I18nFeedbackEnum.FEEDBACK_RATE_OK,
	},
	{
		value: RateTypeEnum.GOOD,
		icon: IconEnum.RATE_GOOD,
		iconSelected: IconEnum.RATE_GOOD_C,
		i18nKey: I18nFeedbackEnum.FEEDBACK_RATE_GOOD,
	},
	{
		value: RateTypeEnum.EXTRAORDINARY,
		icon: IconEnum.RATE_EXTRAORDINARY,
		iconSelected: IconEnum.RATE_EXTRAORDINARY_C,
		i18nKey: I18nFeedbackEnum.FEEDBACK_RATE_EXTRAORDINARY,
	},
];
